import { render, staticRenderFns } from "./TextInputDialog.vue?vue&type=template&id=b6f0421a"
import script from "./TextInputDialog.vue?vue&type=script&lang=js"
export * from "./TextInputDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports